import React, { useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const AutoLogout = ({
  delay,
}) => {
  const location = useLocation();
  const t = useRef();

  const logout = () => {
    window.location.href = 'logout';
  };
  const countdown = () => {
    if (t.current) clearTimeout(t.current);
    t.current = setTimeout(logout, delay);
  };

  useEffect(() => {
    countdown();

    return () => {
      if (t.current) clearTimeout(t.current);
    };
  }, [location]);

  return <></>;
};

export default AutoLogout;
